// extracted by mini-css-extract-plugin
export default {"thumb":"YsqleUj8jFwkEsGNxUl7"};